import { render, staticRenderFns } from "./arrowsChange.vue?vue&type=template&id=46f2ef70&scoped=true&"
import script from "./arrowsChange.vue?vue&type=script&lang=js&"
export * from "./arrowsChange.vue?vue&type=script&lang=js&"
import style0 from "./arrowsChange.vue?vue&type=style&index=0&id=46f2ef70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2ef70",
  null
  
)

export default component.exports